import { render, staticRenderFns } from "./DemographicReport.vue?vue&type=template&id=00063655&"
import script from "./DemographicReport.vue?vue&type=script&lang=js&"
export * from "./DemographicReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports